/* eslint-disable @typescript-eslint/no-explicit-any */
import { InitMessage, OfferConfig } from "@vertical-insure/shared";
import { CSSProperties } from "react";

export const configBuilder = (init: InitMessage): OfferConfig => {
  const { client_id, customer, product_config, theme, version, origin } = init;

  // we need to make sure these have defaults since we are passing them to stripe elements
  const colorPrimary = theme?.colors?.primary ?? '#00263c';
  const colorError = theme?.colors?.error ?? '#ff5861';
  const fontFamily = theme?.font_family ?? 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';

  const styles: CSSProperties = {
    ['--theme-color-background' as any]: theme?.colors?.background ?? '#ffffff',
    ['--theme-color-primary' as any]: colorPrimary,
    ['--theme-color-primary-contrast' as any]: theme?.colors?.primary_contrast ?? '#ffffff',
    ['--theme-color-secondary' as any]: theme?.colors?.secondary ?? '#ff6a00',
    ['--theme-color-secondary-contrast' as any]: theme?.colors?.secondary_contrast ?? '#ffffff',
    ['--theme-color-error' as any]: colorError,
    ['--theme-color-error-contrast' as any]: theme?.colors?.error_contrast ?? '#000000',
    ['--theme-color-success' as any]: theme?.colors?.success ?? '#00a96e',
    ['--theme-color-success-contrast' as any]: theme?.colors?.success_contrast ?? '#ffffff',
    ['--theme-color-neutral' as any]: theme?.colors?.neutral ?? '#d7dde4',
    ['--theme-color-neutral-contrast' as any]: theme?.colors?.neutral_contrast ?? '#00263c',
    ['--theme-color-border' as any]: '#979797',
    ['--theme-font-family' as any]: fontFamily,
    ['--theme-border-radius' as any]: '4px',
  }

  let font_url = '';
  if (theme?.font_family) {
    font_url = `https://fonts.googleapis.com/css2?family=${theme?.font_family.split(' ').join('+')}:ital,wght@0,100..900;1,100..900&display=swap`;
  }

  const payments = {
    enabled: init.payments?.enabled ?? false,
    button: init.payments?.button ?? false
  }

  const is_test = !!client_id?.startsWith('test_');

  return {
    styles,
    version,
    font_url,
    client_id,
    customer,
    product_config,
    origin,
    payments,
    theme: {
      ...theme,
      colors: {
        ...theme?.colors,
        primary: colorPrimary,
        error: colorError,
      },
      font_family: fontFamily
    },
    is_test,
    hide_on_error: init.hide_on_error === undefined ? true : init.hide_on_error
  }
}